/***************************************************************************************************
 * Load `$localize` onto the global scope - used if i18n tags appear in Angular templates.
 */
import '@angular/localize/init';
/**
 * This file includes polyfills needed by Angular and is loaded before the app.
 * You can add your own extra polyfills to this file.
 *
 * This file is divided into 2 sections:
 *   1. Browser polyfills. These are applied before loading ZoneJS and are sorted by browsers.
 *   2. Application imports. Files imported after ZoneJS that should be loaded before your main
 *      file.
 *
 * The current setup is for so-called "evergreen" browsers; the last versions of browsers that
 * automatically update themselves. This includes Safari >= 10, Chrome >= 55 (including Opera),
 * Edge >= 13 on the desktop, and iOS 10 and Chrome on mobile.
 *
 * Learn more in https://angular.io/guide/browser-support
 */

/***************************************************************************************************
 * BROWSER POLYFILLS
 */

/**
 * By default, zone.js will patch all possible macroTask and DomEvents
 * user can disable parts of macroTask/DomEvents patch by setting following flags
 * because those flags need to be set before `zone.js` being loaded, and webpack
 * will put import in the top of bundle, so user need to create a separate file
 * in this directory (for example: zone-flags.ts), and put the following flags
 * into that file, and then add the following code before importing zone.js.
 * import './zone-flags.ts';
 *
 * The flags allowed in zone-flags.ts are listed here.
 *
 * The following flags will work for all browsers.
 *
 * (window as any).__Zone_disable_requestAnimationFrame = true; // disable patch requestAnimationFrame
 * (window as any).__Zone_disable_on_property = true; // disable patch onProperty such as onclick
 * (window as any).__zone_symbol__UNPATCHED_EVENTS = ['scroll', 'mousemove']; // disable patch specified eventNames
 *
 *  in IE/Edge developer tools, the addEventListener will also be wrapped by zone.js
 *  with the following flag, it will bypass `zone.js` patch for IE/Edge
 *
 *  (window as any).__Zone_enable_cross_context_check = true;
 *
 */

/***************************************************************************************************
 * Zone JS is required by default for Angular itself.
 */
import 'zone.js';  // Included with Angular CLI.

/**
	 * Previously I was using webrtc-adapter, but this was using up nearly half the JS bundle size!
	 * This is a more lightweight shim based on the version here: 
	 * https://developer.mozilla.org/en-US/docs/Web/API/MediaDevices/getUserMedia
	 */
	function WebRTCShim () {
        // Some browsers partially implement mediaDevices. We can't just assign an object
        // with getUserMedia as it would overwrite existing properties.
        var n = <any>navigator;
        console.log('Start checking media devices', n);
        if (n.mediaDevices === undefined || n.mediaDevices.getUserMedia === undefined) {
            console.log('Media devices check complete');
          // First get hold of the legacy getUserMedia, if present
          var getUserMedia = n.webkitGetUserMedia || n.mozGetUserMedia;
  
          // If there is no legacy getUserMedia either, do not attempt to shim, we'll check if
          // n.mediaDevices.getUserMedia exists in order to display the button or not.
          if (getUserMedia) {
  
            if (n.mediaDevices === undefined) {
              n.mediaDevices = {};
            }
  
            n.mediaDevices.getUserMedia = function (constraints) {
              // Wrap the call to the old n.getUserMedia with a Promise
              return new Promise(function (resolve, reject) {
                getUserMedia.call(n, constraints, resolve, reject);
              });
            };
          }
        }
      }
      WebRTCShim();
/***************************************************************************************************
 * APPLICATION IMPORTS
 */
